import styled, { css } from 'styled-components';
import * as colors from '../../../common/colorConstants';

export const FilterBlock = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.lightGray21};
  padding-bottom: 20px;
  margin-bottom: 20px;

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 16px;
  }
`;

export const FilterBlockHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const FilterBlockTitle = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 1.45;
  color: ${colors.blue1};
`;

export const HideShowToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
  cursor: pointer;

  span {
    font-family: 'Roboto', sans-serif;
    font-weight: 500;
    font-size: 11px;
    line-height: 1.45;
    color: ${colors.blue1};
    text-align: center;
  }

  img {
    width: 8px;
    height: 4px;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FilterLine = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  flex: 1;
  min-width: 0;
`;

export const touchedInputBorder = css`
  > * > button,
  > * > div:first-child,
  input,
  [class*='-control'] {
    border-color: ${colors.filterTouchedBorder} !important;
    transition: border-color 0.3s ease;
  }
`;

export const FilterInput = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  width: 100%;

  > * {
    width: 100%;
  }

  ${(props) => props.$isTouched && touchedInputBorder}
`;

export const FilterLineLabel = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.45;
  color: ${colors.black4};
  min-width: 56px;
  width: 56px;
  flex-shrink: 0;
  text-align: left;
`;

export const IdentifierInput = styled.input`
  height: 25px;
  width: 100%;
  background-color: ${(props) => (props.disabled ? colors.lightGray7 : colors.white)};
  color: ${(props) => (props.disabled ? colors.inputGrey : colors.black4)};
  border: 1px solid ${colors.lightGray21};
  border-radius: 4px;
  padding: 0 8px;
  font-family: 'Roboto', sans-serif;
  font-weight: ${(props) => (props.disabled ? 500 : 400)};
  font-size: 11px;

  &:focus {
    outline: none;
    border-color: ${colors.blue1};
  }

  &::placeholder {
    color: ${colors.inputGrey};
    font-weight: 500;
  }
`;
